<template>
  <div class="content">
    <base-block class="mb-0" rounded title="Edit Group Questions">
      <div class="row">
        <div class="col-md-6 form-group">
          Parent Topic
          <b-form-select v-model="parentTopic" @change="getTopics()" disabled>
            <option
              v-for="(parentTopic, index) in parentTopics"
              :key="index"
              :value="parentTopic.id"
            >
              {{ parentTopic.name }}
            </option>
          </b-form-select>
          <div v-if="parentTopicEmpty" style="color: red">
            Parent topic is required
          </div>
        </div>

        <div class="col-md-6 form-group">
          Topic
          <b-form-select v-model="topic" @change="getSubtopics()" disabled>
            <option
              v-for="(topic, index) in topics"
              :key="index"
              :value="topic.id"
            >
              {{ topic.name }}
            </option>
            ></b-form-select
          >
          <div v-if="topicEmpty" style="color: red">Topic is required</div>
        </div>

        <div class="col-md-6 form-group">
          Sub Topic
          <b-form-select
            v-model="subtopic"
            @change="subtopicEmpty = false"
            disabled
          >
            <option
              v-for="(subtopic, index) in subtopics"
              :key="index"
              :value="subtopic.id"
            >
              {{ subtopic.name }}
            </option>
          </b-form-select>
          <div v-if="subtopicEmpty" style="color: red">
            Subtopic is required
          </div>
        </div>

        <div class="col-md-6 form-group">
          Question Image
          <b-form-file
            type="file"
            class="form-control"
            v-model="questionImage"
            @change="questionImageUpload"
          ></b-form-file>
        </div>

        <div class="col-md-12 form-group">
          Question
          <vue-editor
            :config="config"
            v-model="question"
            @focus="questionEmpty = false"
            required
          />
          <!-- <ckeditor
            :config="config"
            v-model="question"
            @focus="questionEmpty = false"
            required
          ></ckeditor> -->
          <div v-if="questionEmpty" style="color: red">
            Question is required
          </div>
        </div>
      </div>

      <!-- row 2 -->
      <div class="row" v-for="(qstn, index1) in sub" :key="index1">
        <hr
          style="width: 100%; color: gray; background-color: gray; height: 1px"
        />

        <div class="col-md-6 form-group">
          Group Question Type
          <b-form-select
            class="form-control"
            v-model="sub[index1].type"
            @change="subTypeEmpty = false"
            disabled
          >
            <option
              v-for="(questionTypeOption, index) in questionTypeOptions"
              :key="index"
              :value="questionTypeOption.value"
            >
              {{ questionTypeOption.text }}
            </option>
          </b-form-select>
          <div v-if="subTypeEmpty && sub[index1].type == ''" style="color: red">
            Group question type is required
          </div>
        </div>

        <!-- Fillups -->

        <div class="col-md-6 form-group">
          Sub Question Image
          <b-form-file
            type="file"
            class="form-control"
            v-model="sub[index1].subquestionImage"
            @change="subquestionImageUpload(index1, $event)"
          ></b-form-file>
        </div>

        <div class="col-md-12 form-group">
          Sub Question
          <vue-editor
            :config="config"
            v-model="sub[index1].subQstn"
            @focus="subQstnEmpty = false"
            required
          />
          <!-- <ckeditor
            :config="config"
            v-model="sub[index1].subQstn"
            @focus="subQstnEmpty = false"
            required
          ></ckeditor> -->
          <div
            v-if="subQstnEmpty && sub[index1].subQstn == ''"
            style="color: red"
          >
            Subquestion is required
          </div>
        </div>

        <div
          class="col-md-6"
          v-for="(option, index) in sub[index1].options"
          :key="index"
        >
          <div class="form-group" v-if="sub[index1].type == 'objective'">
            Option {{ index + 1 }}
            <input
              class="form-control"
              placeholder="Enter an option"
              v-model="sub[index1].options[index].option"
              @focus="option1Empty = false"
            />
            <div
              v-if="option1Empty && sub[index1].options[index].option == ''"
              style="color: red"
            >
              Option is required
            </div>
          </div>
        </div>

        <div class="col-md-6 form-group" v-if="sub[index1].type != 'objective'">
          Correct Answer
          <input
            class="form-control"
            v-model="sub[index1].correctAnswer"
            @focus="correctAnswerEmpty = false"
          />
          <div
            v-if="correctAnswerEmpty && sub[index1].correctAnswer == ''"
            style="color: red"
          >
            Correct answer is required
          </div>
        </div>

        <div class="col-md-6 form-group" v-if="sub[index1].type == 'objective'">
          Correct Option
          <b-form-select
            class="form-control"
            v-model="sub[index1].correctAnswer"
            @focus="correctAnswerEmpty = false"
          >
            <option
              v-for="(option, index) in sub[index1].options"
              :key="index"
              :value="option.option"
            >
              {{ index + 1 }}
            </option>
          </b-form-select>
          <div
            v-if="correctAnswerEmpty && sub[index1].correctAnswer == ''"
            style="color: red"
          >
            Correct option is required
          </div>
        </div>

        <div
          class="row m-0"
          style="width: 100%"
          v-for="(soln, index) in sub[index1].moreSolution"
          :key="index"
        >
          <div
            class="col-md-6 form-group"
            v-if="sub[index1].correctAnswer != ''"
          >
            Solution Type
            <b-form-select
              class="form-control"
              v-model="sub[index1].moreSolution[index].type"
              @change="solutionTypeEmpty = false"
            >
              <option value="video">video</option>
              <option value="description">description</option>
            </b-form-select>
            <div
              v-if="
                solutionTypeEmpty && sub[index1].moreSolution[index].type == ''
              "
              style="color: red"
            >
              Solution type is required
            </div>
          </div>

          <div
            class="col-md-5 form-group"
            v-if="
              sub[index1].moreSolution[index].type == 'description' &&
                sub[index1].correctAnswer != ''
            "
          >
            Solution Image
            <b-form-file
              type="file"
              class="form-control"
              v-model="sub[index1].moreSolution[index].image"
              @change="solutionImageUpload(index1, index, $event)"
            />
          </div>

          <div
            class="col-md-5 form-group"
            v-if="
              sub[index1].moreSolution[index].type == 'video' &&
                sub[index1].correctAnswer != ''
            "
          >
            Video Name
            <input
              class="form-control"
              v-model="sub[index1].moreSolution[index].description"
              @focus="solutionNameEmpty = false"
            />
            <div
              v-if="
                solutionNameEmpty &&
                  sub[index1].moreSolution[index].description == ''
              "
              style="color: red"
            >
              Video name is required
            </div>
          </div>

          <div
            class="col-md-1 form-group"
            v-if="
              sub[index1].moreSolution[index].type != '' &&
                sub[index1].correctAnswer != ''
            "
          >
            <b-button
              variant="danger"
              class="mt-4"
              @click="
                removeSolution(
                  index1,
                  index,
                  sub[index1].moreSolution[index].id
                )
              "
              ><i class="fas fa-trash"></i
            ></b-button>
          </div>

          <div
            class="col-md-12 form-group"
            v-if="
              sub[index1].moreSolution[index].type == 'video' &&
                sub[index1].moreSolution[index].type != '' &&
                sub[index1].correctAnswer != ''
            "
          >
            Solution
            <input
              class="form-control"
              placeholder="Enter URL"
              v-model="sub[index1].moreSolution[index].video_url"
              @focus="solutionURLEmpty = false"
            />
            <div
              v-if="
                solutionURLEmpty &&
                  sub[index1].moreSolution[index].video_url == ''
              "
              style="color: red"
            >
              Solution URL is required
            </div>
          </div>
          <div
            class="col-md-12 form-group"
            v-if="
              sub[index1].moreSolution[index].type == 'description' &&
                sub[index1].moreSolution[index].type != '' &&
                sub[index1].correctAnswer != ''
            "
          >
            Solution
            <vue-editor
              :config="config"
              v-model="sub[index1].moreSolution[index].description"
              @focus="solutionDescriptionEmpty = false"
            />
            <!-- <ckeditor
              :config="config"
              v-model="sub[index1].moreSolution[index].description"
              @focus="solutionDescriptionEmpty = false"
            ></ckeditor> -->
            <div
              v-if="
                solutionDescriptionEmpty &&
                  sub[index1].moreSolution[index].description == ''
              "
              style="color: red"
            >
              Solution description is required
            </div>
          </div>
        </div>
        <div
          class="text-right col-md-12 form-group"
          v-if="sub[index1].correctAnswer != ''"
        >
          <b-button variant="success" @click="appendMoreSolution(index1)"
            >Add Solution</b-button
          >
        </div>
      </div>
      <div
        class="text-center form-group"
        v-if="sub[sub.length - 1].correctAnswer"
      >
        <b-button variant="success" @click="addGroupQuestion()" type="submit"
          >Save Changes</b-button
        >
      </div>
      <!-- Loader -->
      <b-overlay
        :show="loader"
        no-wrap
        blur="2px"
        opacity="0.60"
        class="position-fixed"
      >
        <template #overlay>
          <i class="fa fa-3x fa-cog fa-spin text-primary"></i>
        </template>
      </b-overlay>
    </base-block>
    <br />
  </div>
</template>
<script>
import axios from "axios";
export default {
  mounted() {
    this.getParentTopics();
    this.loadData();
  },
  methods: {
    async loadData() {
      await axios
        .get(
          `${this.$store.getters.baseUrl}/question/edit/${this.$route.params.id}`,
          {
            headers: { Authorization: `Bearer ${this.$store.getters.token}` },
          }
        )
        .then(async (response) => {
          console.log(response);
          if (response.data.status == "success") {
            this.id = response.data.question.id;
            this.parentTopic = response.data.question.belongtopics[0].id;
            this.getTopics();
            this.topic = response.data.question.belongtopics[1].id;
            this.getSubtopics();
            this.subtopic = response.data.question.belongtopics[2].id;
            this.questionImage = "";
            this.question = response.data.question.question;
            if (response.data.question.subquestions.length > 0) {
              for (
                var i = 0;
                i < response.data.question.subquestions.length;
                i++
              ) {
                this.sub.push({
                  id: response.data.question.subquestions[i].id,
                  type: response.data.question.subquestions[i].question_type,
                  subquestionImage: "",
                  subQstn: response.data.question.subquestions[i].question,
                  options: response.data.question.subquestions[i].options,
                  correctAnswer: response.data.question.subquestions[i].answer,
                  moreSolution:
                    response.data.question.subquestions[i].solutions,
                });
              }
            }
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
    },

    async removeSolution(index1, index, id) {
      if (id) {
        await axios
          .get(`${this.$store.getters.baseUrl}/solution/delete/${id}`, {
            headers: {
              Authorization: `Bearer ${this.$store.getters.token}`,
            },
          })
          .then((response) => {
            console.log(response);
            if (response.data.status == "success") {
              this.sub[index1].moreSolution.splice(index, 1);
            } else {
              this.$swal("Error", response.data.message, "warning");
            }
          })
          .catch((error) => {
            console.log(error);
            this.$swal("Error", error.response.data.message, "error");
          });
      } else {
        this.sub[index1].moreSolution.splice(index, 1);
      }
    },

    questionImageUpload(event) {
      this.questionImage = event.target.files[0];
    },

    subquestionImageUpload(index1, event) {
      this.sub[index1].subquestionImage = event.target.files[0];
    },

    solutionImageUpload(index1, index, event) {
      this.sub[index1].moreSolution[index].image = event.target.files[0];
    },

    async addGroupQuestion() {
      if (this.parentTopic == "") {
        this.parentTopicEmpty = true;
        return;
      }

      if (this.topic == "") {
        this.topicEmpty = true;
        return;
      }

      if (this.subtopic == "") {
        this.subtopicEmpty = true;
        return;
      }

      if (this.question == "") {
        this.questionEmpty = true;
        return;
      }

      for (var x = 0; x < this.sub.length; x++) {
        if (this.sub[x].type == "") {
          this.subTypeEmpty = true;
          return;
        }

        if (this.sub[x].subQstn == "") {
          this.subQstnEmpty = true;
          return;
        }

        if (this.sub[x].type == "objective") {
          for (var t = 0; t < this.sub[x].options.length; t++) {
            if (this.sub[x].options[t] == "") {
              this.option1Empty = true;
              return;
            }
          }
        }

        if (this.sub[x].correctAnswer == "") {
          this.correctAnswerEmpty = true;
          return;
        }

        if (this.sub[x].moreSolution.length > 0) {
          for (var z = 0; z < this.sub[x].moreSolution.length; z++) {
            if (this.sub[x].moreSolution[z].type == "") {
              this.solutionTypeEmpty = true;
              return;
            }
            if (this.sub[x].moreSolution[z].type == "video") {
              if (this.sub[x].moreSolution[z].video_url == "") {
                this.solutionURLEmpty = true;
                return;
              }

              if (this.sub[x].moreSolution[z].description == "") {
                this.solutionNameEmpty = true;
                return;
              }
            } else {
              if (this.sub[x].moreSolution[z].description == "") {
                this.solutionDescriptionEmpty = true;
                return;
              }
            }
          }
        }
      }
      this.loader = true;
      let topicIds = [this.parentTopic, this.topic, this.subtopic];
      const formdata = new FormData();
      formdata.append("question_id", this.id);
      formdata.append("topic_id", this.subtopic);
      formdata.append("question", this.question);
      formdata.append("image", this.questionImage);
      formdata.append("topic_ids", topicIds);

      for (var i = 0; i < this.sub.length; i++) {
        if (this.sub[i].type == "Fillups") {
          formdata.append("group_questions[" + i + "][id]", this.sub[i].id);
          formdata.append(
            "group_questions[" + i + "][question_type]",
            "fill_in_blank"
          );
          formdata.append(
            "group_questions[" + i + "][image]",
            this.sub[i].subquestionImage
          );
          formdata.append(
            "group_questions[" + i + "][question]",
            this.sub[i].subQstn
          );
          console.log(this.sub[i].subQstn);
          formdata.append(
            "group_questions[" + i + "][answer]",
            this.sub[i].correctAnswer
          );
          for (var j = 0; j < this.sub[i].moreSolution.length; j++) {
            if (this.sub[i].moreSolution[j].type == "video") {
              formdata.append(
                "group_questions[" + i + "][solutions][" + j + "][id]",
                this.sub[i].moreSolution[j].id
                  ? this.sub[i].moreSolution[j].id
                  : ""
              );
              formdata.append(
                "group_questions[" + i + "][solutions][" + j + "][type]",
                "video"
              );
              formdata.append(
                "group_questions[" + i + "][solutions][" + j + "][video_url]",
                this.sub[i].moreSolution[j].video_url
              );
              formdata.append(
                "group_questions[" + i + "][solutions][" + j + "][video_name]",
                this.sub[i].moreSolution[j].description
              );
            } else {
              formdata.append(
                "group_questions[" + i + "][solutions][" + j + "][id]",
                this.sub[i].moreSolution[j].id
                  ? this.sub[i].moreSolution[j].id
                  : ""
              );
              formdata.append(
                "group_questions[" + i + "][solutions][" + j + "][type]",
                "description"
              );
              formdata.append(
                "group_questions[" + i + "][solutions][" + j + "][description]",
                this.sub[i].moreSolution[j].description
              );
              formdata.append(
                "group_questions[" + i + "][solutions][" + j + "][image]",
                this.sub[i].moreSolution[j].image
              );
            }
          }
        } else {
          formdata.append("group_questions[" + i + "][id]", this.sub[i].id);
          formdata.append(
            "group_questions[" + i + "][question_type]",
            "objective"
          );
          formdata.append(
            "group_questions[" + i + "][image]",
            this.sub[i].subquestionImage
          );
          formdata.append(
            "group_questions[" + i + "][question]",
            this.sub[i].subQstn
          );
          console.log(this.sub[i].subQstn);
          for (var b = 0; b < this.sub[i].options.length; b++) {
            formdata.append(
              "group_questions[" + i + "][options][" + b + "][id]",
              this.sub[i].options[b].id
            );
            formdata.append(
              "group_questions[" + i + "][options][" + b + "][option]",
              this.sub[i].options[b].option
            );
          }
          formdata.append(
            "group_questions[" + i + "][answer]",
            this.sub[i].correctAnswer
          );
          for (var l = 0; l < this.sub[i].moreSolution.length; l++) {
            if (this.sub[i].moreSolution[l].type == "video") {
              formdata.append(
                "group_questions[" + i + "][solutions][" + l + "][id]",
                this.sub[i].moreSolution[l].id
                  ? this.sub[i].moreSolution[l].id
                  : ""
              );
              formdata.append(
                "group_questions[" + i + "][solutions][" + l + "][type]",
                "video"
              );
              formdata.append(
                "group_questions[" + i + "][solutions][" + l + "][video_url]",
                this.sub[i].moreSolution[l].video_url
              );
              formdata.append(
                "group_questions[" + i + "][solutions][" + l + "][video_name]",
                this.sub[i].moreSolution[l].description
              );
            } else {
              formdata.append(
                "group_questions[" + i + "][solutions][" + l + "][id]",
                this.sub[i].moreSolution[l].id
                  ? this.sub[i].moreSolution[l].id
                  : ""
              );
              formdata.append(
                "group_questions[" + i + "][solutions][" + l + "][type]",
                "description"
              );
              formdata.append(
                "group_questions[" + i + "][solutions][" + l + "][description]",
                this.sub[i].moreSolution[l].description
              );
              formdata.append(
                "group_questions[" + i + "][solutions][" + l + "][image]",
                this.sub[i].moreSolution[l].image
              );
            }
          }
        }
      }
      await axios
        .post(
          `${this.$store.getters.baseUrl}/question/group_update/${this.id}`,
          formdata,
          {
            headers: {
              Authorization: `Bearer ${this.$store.getters.token}`,
            },
          }
        )
        .then((response) => {
          console.log(response);
          if (response.data.status == "success") {
            this.loader = false;
            this.$swal(
              "Success",
              "Group question updated successfully",
              "success"
            );
            this.$router.push({ name: "Tables Questions" });
            (this.parentTopic = ""),
              (this.topic = ""),
              (this.subtopic = ""),
              (this.question = ""),
              (this.questionImage = "");
            this.sub = [];
            this.topicEmpty = false;
            this.parentTopicEmpty = false;
            this.subTypeEmpty = false;
            this.questionEmpty = false;
            this.subTypeEmpty = false;
            this.subQstnEmpty = false;
            this.solutionDescriptionEmpty = false;
            this.solutionURLEmpty = false;
            this.option2Empty = false;
            this.option1Empty = false;
            this.solutionNameEmpty = false;
            this.solutionTypeEmpty = false;
            this.correctAnswerEmpty = false;
          } else {
            this.loader = false;
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.loader = false;
          this.$swal("Error", error.response.data.message, "error");
        });
    },
    async getParentTopics() {
      await axios
        .get(`${this.$store.getters.baseUrl}/topics`, {
          headers: {
            Authorization: `Bearer ${this.$store.getters.token}`,
          },
        })
        .then((response) => {
          console.log(response);
          this.parentTopics = response.data.topics;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
    },

    async getTopics() {
      this.parentTopicEmpty = false;
      this.topic = "";
      await axios
        .get(`${this.$store.getters.baseUrl}/topics/${this.parentTopic}`, {
          headers: {
            Authorization: `Bearer ${this.$store.getters.token}`,
          },
        })
        .then((response) => {
          console.log(response);
          this.topics = response.data.topics;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
    },

    async getSubtopics() {
      this.topicEmpty = false;
      this.subtopic = "";
      await axios
        .get(`${this.$store.getters.baseUrl}/topics/${this.topic}`, {
          headers: {
            Authorization: `Bearer ${this.$store.getters.token}`,
          },
        })
        .then((response) => {
          console.log(response);
          this.subtopics = response.data.topics;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
    },

    buttonEnable() {
      return this.sub[this.sub.length - 1].correctAnswer;
    },

    appendMoreSolution(index1) {
      this.sub[index1].moreSolution = [
        ...this.sub[index1].moreSolution,
        {
          id: "",
          type: "",
          video_url: "",
          description: "",
          image: "",
        },
      ];
    },
  },
  data() {
    return {
      config: {
        toolbar: [
          {
            name: "clipboard",
            groups: ["clipboard", "undo"],
            items: [
              "Cut",
              "Copy",
              "Paste",
              "PasteText",
              "PasteFromWord",
              "-",
              "Undo",
              "Redo",
            ],
          },
          {
            name: "editing",
            groups: ["find", "selection", "spellchecker"],
            items: ["Find", "Replace", "-", "SelectAll", "-", "Scayt"],
          },
          { name: "links", items: ["Link", "Unlink", "Anchor"] },
          {
            name: "insert",
            items: [
              "Image",
              "Flash",
              "Table",
              "HorizontalRule",
              "Smiley",
              "SpecialChar",
              "PageBreak",
              "Iframe",
            ],
          },
          { name: "tools", items: ["Maximize", "ShowBlocks"] },
          {
            name: "document",
            groups: ["mode", "document", "doctools"],
            items: ["Source"],
          },
          {
            name: "basicstyles",
            groups: ["basicstyles", "cleanup"],
            items: [
              "Bold",
              "Italic",
              "Underline",
              "Strike",
              "Subscript",
              "Superscript",
              "-",
              "CopyFormatting",
              "RemoveFormat",
            ],
          },
          "/",
          {
            name: "paragraph",
            groups: ["list", "indent", "blocks", "align", "bidi"],
            items: [
              "NumberedList",
              "BulletedList",
              "-",
              "Outdent",
              "Indent",
              "-",
              "Blockquote",
              "CreateDiv",
              "-",
              "JustifyLeft",
              "JustifyCenter",
              "JustifyRight",
              "JustifyBlock",
              "-",
              "BidiLtr",
              "BidiRtl",
              "Language",
            ],
          },

          { name: "styles", items: ["Styles", "Format", "Font", "FontSize"] },
          { name: "colors", items: ["TextColor", "BGColor"] },
          { name: "others", items: ["-"] },
          { name: "about", items: ["About"] },
          { name: "mathjax", items: ["Mathjax"] },
        ],
        extraPlugins: ["mathjax", "font", "justify"],
        mathJaxLib:
          "//cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.5/MathJax.js?config=TeX-AMS_HTML",
      },
      id: "",
      questionTypeOptions: [
        {
          text: "Fillups",
          value: "fill_in_blank",
        },
        {
          text: "MCQ",
          value: "objective",
        },
      ],
      loader: false,
      solutionDescriptionEmpty: false,
      solutionTypeEmpty: false,
      solutionNameEmpty: false,
      solutionURLEmpty: false,
      correctAnswerEmpty: false,
      option1Empty: false,
      option2Empty: false,
      subQstnEmpty: false,
      subTypeEmpty: false,
      questionEmpty: false,
      parentTopicEmpty: false,
      topicEmpty: false,
      subtopicEmpty: false,
      parentTopic: "",
      parentTopics: [],
      topic: "",
      topics: [],
      subtopic: "",
      subtopics: [],
      question: "",
      questionImage: "",
      sub: [],
    };
  },
};
</script>
